import { AdaaHelper } from "../../../../../../../core/utils";
import { AccordionSectionConfigType, ScreenSectionConfigType, ScreenType } from "../../wf-difference.types";

const nameField: ScreenSectionConfigType = {
  field: "projectId",
  label: "initiatives.project",
  view: "normal",
  format: ($o) => AdaaHelper.getItemValueByToken($o, "projectName"),
};

const countryField: ScreenSectionConfigType = {
  field: "countryId",
  label: "international_projects.countries.single",
  view: "normal",
  format: ($o) => AdaaHelper.getItemValueByToken($o, "countryName"),
};

const orderField: ScreenSectionConfigType = {
  field: "projectOrder",
  label: "common.form.label.order",
  view: "normal",
};

const orderSectionConfig: ScreenSectionConfigType[] = [nameField, orderField, countryField];

const projectOrderListsField: AccordionSectionConfigType = {
  view: "accordion",
  field: "projectOrderLists",
  title: ($o) => AdaaHelper.getItemValueByToken($o, "projectName"),
  idKey: "id",
  config: orderSectionConfig,
  label: "international_projects.countries.sort_projects",
};

export const projectOrdersScreenConfig = {
  type: "simple" as ScreenType,
  sections: [projectOrderListsField],
};
